import React from 'react';
import '../styles/SuccessModal.css';

function SuccessModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="success-modal">
        <button className="modal-close" onClick={onClose}>&times;</button>
        <div className="success-content">
          <div className="success-icon">✓</div>
          <h2>Thank You!</h2>
          <p>Your information has been submitted successfully. We will reach out to you once we have space available in our beta program.</p>
        </div>
      </div>
    </div>
  );
}

export default SuccessModal; 